import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkCookieSearchData, init } from '../../actions/baseActions';

import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';
import { resetBlogLocation, setBlogLocation } from '../../actions/blogActions';
import sanityAPI from '../../app/api/sanity';
// @ts-ignore
import store from '../../store';

const DynamicBlog = dynamic(() => import('../../app/components/Cars/Blog'), { ssr: false });

const Home: NextPage = (props: any) => {
	const dispatch = useDispatch();

	useEffect(() => {
		init('cars')(dispatch);
		checkCookieSearchData()(dispatch);
	}, []);

	useEffect(
		() => () => {
			// @ts-ignore
			store.dispatch(resetBlogLocation());
		},
		[]
	);
	return (
		<div>
			<NextSeo
				title={props.location.metaTitle}
				description={props.location.metaDescription}
				canonical={process.env.NEXT_PUBLIC_SITE_URL + props.router.asPath}
				openGraph={{
					url: `${process.env.NEXT_PUBLIC_SITE_URL + props.router.asPath}`,
					title: props.location.metaTitle,
					description: props.location.metaDescription,
					site_name: process.env.NEXT_PUBLIC_SITE_NAME,
				}}
			/>
			<DynamicBlog
				locationObject={props.location}
				locationForScheme={props.locationForScheme}
				slug={props.router.asPath}
				query={
					// @ts-ignore
					props.query
				}
			/>
		</div>
	);
};

// @ts-ignore
export async function getServerSideProps(context) {
	const { res } = context;
	const slug = context.params.slug;
	const location = await sanityAPI.fetch(`*[_type == "location" && slug.current == "${slug}" ][0]`);
	if (!location) {
		if (res) {
			res.statusCode = 404;
		}
		return {
			// <-----------------does the trick here!!
			notFound: true,
		};
	}

	const locationForScheme = {
		url: `https://therentalradar.com/destination/${slug}`,
		name: location.headingOne,
		description: location.metaDescription,
	};
	// @ts-ignore
	store.dispatch(setBlogLocation(locationForScheme));
	return {
		props: {
			location,
			locationForScheme,
		}, // will be passed to the page component as props
	};
}

export default withRouter(Home);
